import React, { PropTypes } from 'react';
import partial from 'lodash/partial';
import first from 'lodash/first';
import StarRating from 'common/components/star_rating';
import Thumbnail from 'common/components/thumbnail';
import { getVoteStats } from 'presentations/utils';

const ResultTile = ({ id, votes, revision, entry_number, comment_count, presentation, onClick }) => {
  const thumbnailImage = first(revision.thumbnails);
  const { averageScore, voteCount } = getVoteStats({
    revisions: [ { votes } ],
    presentation
  });

  return (
    <div className="column" onClick={partial(onClick, id)} >
      <div className="tile presentation-result-tile">
        <div className="row align-center">
          <div className="columns small-16 medium-5 large-5">
            <Thumbnail className="thumbnail flex" image={thumbnailImage} />
          </div>
          <div className="columns small-16 medium-11 large-11 align-middle">
            <h4>Entry #{entry_number}</h4>
            <div className="presentation-stats tile-stats">
              <div className="row collapse small-up-3 medium-up-4">
                <div className="column">
                  <span className="stat-label">Group Score</span>
                  <div className="stat-value">{ averageScore }</div>
                </div>
                <div className="column">
                  <span className="stat-label">Votes</span>
                  <div className="stat-value">{ voteCount }</div>
                </div>
                <div className="column">
                  <span className="stat-label">Comments</span>
                  <div className="stat-value">{ comment_count }</div>
                </div>
                <div className="column hide-for-small-only">
                  <span className="stat-label">Your Score</span>
                  <div className="stat-value">
                    <StarRating readonly={true} initialRate={revision.score}/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ResultTile.propTypes = {
  id: PropTypes.number.isRequired,
  votes: PropTypes.object.isRequired,
  revision: PropTypes.object.isRequired,
  presentation: PropTypes.object.isRequired,
  entry_number: PropTypes.number.isRequired,
  comment_count: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default ResultTile;



// WEBPACK FOOTER //
// ./presentations/components/result_tile.jsx